import { ApolloClient,from } from "@apollo/client";
import { HttpLink } from "apollo-link-http";
import { InMemoryCache } from "apollo-cache-inmemory";
import { onError } from "@apollo/client/link/error";
import { reportError } from "@/helpers/errorHelper";

const domain = process.env.SHOPIFY_STORE_DOMAIN;
const storeFrontAccessToken = process.env.SHOPIFY_STOREFRONT_ACCESSTOKEN;

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(({ message, locations, path }) =>
      { 
        console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`);
        reportError("Apolloclient [GraphQL error] error : ", message, locations, path);
      }
    );
  if (networkError){  
    console.error(`[Network error]: ${networkError}`);
    reportError("Apolloclient [Network error] error : ",networkError);
  }
});
//OS-4874 Shopify API version update
const httpLink = new HttpLink({
  uri: `https://${domain}/api/2025-01/graphql.json`,
  headers: {
    "X-shopify-Storefront-Access-Token": storeFrontAccessToken,
  },
})


const apolloClient = new ApolloClient({
  link: from([errorLink, httpLink]),
  cache: new InMemoryCache(),
});

export default apolloClient;
